import script from "./MagamBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./MagamBtn.vue?vue&type=script&setup=true&lang=ts"

import "./MagamBtn.vue?vue&type=style&index=0&id=7068ecf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7068ecf8"]])

export default __exports__